import React, { useEffect, useState } from "react";
import PostOverView from "./post/PostOverView";
import withStyles from "@mui/styles/withStyles";
import { Alert, Box, Button, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import axios from "axios";
import CheckIcon from "@mui/icons-material/Check";
import Loading from "../../../shared/components/Loading";
import Create from "./create/Create";
import { useTheme } from "@mui/styles";

const styles = (theme) => ({
  wrapper: {
    background: theme.palette.primary.backgroundAlt,
  },

  headWrapper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    background:
      theme.palette.mode === "light"
        ? "linear-gradient(180deg, #F3F0F9 0%, #DBCAFF 79.1%)"
        : "unset",
    overflowY: "hidden",
  },

  container: {
    zIndex: 1,
    width: "100%",
    maxWidth: "1170px",
    marginLeft: "auto",
    marginRight: "auto",
    padding: "calc(5em + 130px) 2em 5em 2em",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",

    [theme.breakpoints.up("lg")]: {
      maxWidth: "1350px",
    },

    [theme.breakpoints.down("md")]: {
      paddingLeft: "1em",
      paddingRight: "1em",
    },
  },

  mainHeading: {
    width: "100%",
    textAlign: "center",
    letterSpacing: "-3.6px",
    fontSize: "104px",
    fontFamily: "Poppins, sans-serif",
    fontWeight: 600,
    lineHeight: 1.1,
    display: "block",

    [theme.breakpoints.down("md")]: {
      letterSpacing: "-2px",
      fontSize: "80px",
    },
    [theme.breakpoints.down("sm")]: {
      letterSpacing: "-1px",
      fontSize: "34px",
    },
  },
  headingText: {
    width: "100%",
    maxWidth: "800px",
    color: theme.palette.common.text,
    margin: theme.spacing(4, 0),
    textAlign: "center",
    fontSize: "18px",
    [theme.breakpoints.down("md")]: {
      fontSize: "18px",
    },
    [theme.breakpoints.down("md")]: {
      fontSize: "16px",
    },
  },

  bgImage: {
    position: "absolute",
    opacity: 0.7,

    "& img": {
      width: "100%",
    },
  },
  postsFeed: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(4),
    maxWidth: "980px",
    margin: theme.spacing(4, "auto"),
    [theme.breakpoints.down("sm")]: {
      gap: theme.spacing(2),
      margin: theme.spacing(2, 1),
    },
  },

  alert: {
    position: "absolute",
    top: "-2rem",
    left: "50%",
    transform: "translateX(-50%)",
    maxHeight: "100px",
    transition: "500ms",
  },

  inputWrapper: {
    maxWidth: "980px",
    margin: "2rem auto",
    background:
      theme.palette.mode === "light" ? "#F8FAFC" : theme.palette.common.white,
    padding: theme.spacing(4),
    borderRadius: "24px",
    color: theme.palette.common.textAlt,
  },

  inputContainer: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(4),

    "& > div": {
      display: "flex",
      alignItems: "center",
      width: "100%",
      cursor: "pointer",
    },

    "& .inputField": {
      gap: theme.spacing(2),

      "& svg": {
        fill: theme.palette.common.contrast,
      },

      "& img": {
        background: theme.palette.common.white,
        borderRadius: "50%",
        width: "55px",
        height: "55px",
        objectFit: "cover",
      },

      "& input": {
        width: "100%",
        borderRadius: "32px",
        border: "none",
        padding: theme.spacing(2),
        background: theme.palette.mode === "light" ? "#F1F5F9" : "#1d1d1d",
        fontFamily: "Poppins,sans-serif",

        "&::placeholder": {
          color: theme.palette.common.text,
        },
      },
    },

    "& .icons": {
      justifyContent: "space-around",
      "& > div": {
        display: "flex",
        gap: theme.spacing(1),
        alignItems: "center",
      },
    },
  },

  createPostWrapper: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "rgba(0,0,0,0.5)",
    zIndex: 20,
  },

  createContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    background:
      theme.palette.mode === "light" ? "#F8FAFC" : theme.palette.common.white,
    padding: theme.spacing(4),
    borderRadius: "24px",
    color: theme.palette.common.textAlt,
    width: "100%",
    maxWidth: "910px",
  },

  bgArtifact: {
    position: "relative",
    width: "100%",
    height: "100%",

    "& > div": {
      position: "absolute",
      top: "-100px",
      backgroundColor: "rgba(148, 97, 255, 0.75)",
      boxShadow: "0px 0px 112px 32px rgb(148, 97, 255)",
      filter: "blur(100px)",
      aspectRatio: "1/1",
      width: "100%",
      margin: "0 auto",
      borderRadius: "100%",
    },
  },
});

const SocialHome = ({
  classes,
  userLoggedIn,
  selectCommunity,
  openCreatePost,
  handleToggleCreatePost,
}) => {
  const [posts, setPosts] = useState([]);
  const history = useHistory();
  const location = useLocation();
  const [created, setCreated] = useState(location.state?.created);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  const theme = useTheme();

  const goToAuth = () => {
    history.push({
      pathname: "/auth/login",
      state: { selectedCompany: false },
    });
  };

  //get data
  const fetchData = async () => {
    if (loading || !hasMore) return;

    setLoading(true);
    try {
      const { data } = await axios.get(
        `/api/socials/posts?page=${page}&limit=10`
      );

      setPosts((prevPosts) => [...prevPosts, ...data.posts]);
      setPage((prevPage) => prevPage + 1);

      // Check if there are more posts to load
      setHasMore(data.posts.length > 0);
    } catch (error) {
      console.error("Failed to fetch posts:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + document.documentElement.scrollTop + 500 <
          document.documentElement.offsetHeight ||
        loading ||
        !hasMore
      ) {
        return;
      }

      fetchData();
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [loading, hasMore]);

  useEffect(() => {
    selectCommunity();
    const showSuccessALert = () => {
      if (created) {
        window.history.replaceState({}, "");
        setTimeout(() => {
          setCreated(false);
        }, 3000);
      }
    };
    showSuccessALert();
    fetchData();
  }, [created]);

  const handleWrapperClick = (event) => {
    // Prevent the click event from propagating to the wrapper when clicking inside the Create component
    if (event.target === event.currentTarget) {
      handleToggleCreatePost();
    }
  };

  return (
    <div className={classes.wrapper}>
      <div className={classes.headWrapper}>
        <div className={classes.container}>
          <Typography
            className={classes.mainHeading}
            variant="h1"
            fontWeight={500}
            textAlign="center"
            data-aos="fade-up"
            data-aos-easing="ease-out"
          >
            Auralyze Community
          </Typography>
          <Typography
            data-aos="fade-up"
            data-aos-easing="ease-out"
            data-aos-delay="300"
            className={classes.headingText}
          >
            Join the Auralyze community to connect with fellow students, share
            tips, and stay updated on the latest resources for university
            interview prep. Together, we help each other succeed!
          </Typography>
        </div>

        <div className={classes.bgImage}>
          <img
            src="/images/logged_out/headsection_bg/headsection-bg-3.png"
            alt=""
          />
        </div>

        {theme.palette.mode === "dark" && (
          <div className={classes.bgArtifact}>
            <div></div>
          </div>
        )}
      </div>

      <Box
        className={classes.inputWrapper}
        onClick={() => {
          if (userLoggedIn.logged) {
            handleToggleCreatePost();
          } else {
            goToAuth();
          }
        }}
      >
        <div className={classes.inputContainer}>
          <div className="inputField">
            {userLoggedIn?.img ? (
              <img src={userLoggedIn.img} alt="" />
            ) : (
              <svg
                version="1.1"
                id="Vrstva_1"
                x="0px"
                y="0px"
                viewBox="0 0 100 100"
                width={55}
                height={55}
              >
                <g>
                  <path d="M11.4,93.3c-0.1,0-0.1,0-0.2,0c-1.3-0.1-2.2-1.2-2.1-2.4c1.3-19.1,19.3-34,40.9-34c21.6,0,39.6,14.9,40.9,33.9   c0.1,1.3-0.9,2.3-2.1,2.4c-1.3,0.1-2.3-0.9-2.4-2.1C85.2,74.4,69.2,61.4,50,61.4c-19.3,0-35.3,13.1-36.4,29.8   C13.5,92.4,12.5,93.3,11.4,93.3z" />
                  <path d="M50,52.3c-12.6,0-22.8-10.2-22.8-22.8S37.4,6.7,50,6.7c12.6,0,22.8,10.2,22.8,22.8S62.6,52.3,50,52.3z M50,11.3   c-10,0-18.2,8.2-18.2,18.2S40,47.7,50,47.7c10,0,18.2-8.2,18.2-18.2S60,11.3,50,11.3z" />
                </g>
              </svg>
            )}
            <input
              readOnly
              className="input"
              placeholder={`What's on your mind${
                userLoggedIn.logged ? `, ${userLoggedIn.name}?` : "?"
              }`}
            ></input>
          </div>
          <div className="icons">
            <div>
              <img src="/images/logged_out/icons/images.png" alt="" />
              <Typography>Media</Typography>
            </div>

            <div>
              <img src="/images/logged_out/icons/write.png" alt="" />
              <Typography>Write Articles</Typography>
            </div>
          </div>
        </div>
      </Box>

      <Box className={classes.postsFeed}>
        {posts.map((post, index) => {
          return <PostOverView post={post} />;
        })}
        {loading && <Loading item="Posts" />}
      </Box>

      {openCreatePost && (
        <Box className={classes.createPostWrapper} onClick={handleWrapperClick}>
          <Box className={classes.createContainer}>
            <Create userLoggedIn={userLoggedIn} />
          </Box>
        </Box>
      )}

      {created && (
        <Alert
          className={classes.alert}
          icon={<CheckIcon />}
          severity="success"
        >
          Your post was successfully created
        </Alert>
      )}
    </div>
  );
};

export default withStyles(styles, { withTheme: true })(SocialHome);
